import { render } from "./business-cofounders-modal.vue?vue&type=template&id=01a63ce6&ts=true"
import script from "./business-cofounders-modal.vue?vue&type=script&lang=ts"
export * from "./business-cofounders-modal.vue?vue&type=script&lang=ts"

import "./business-cofounders-modal.vue?vue&type=style&index=0&id=01a63ce6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__